module.exports = __webpack_public_path__ + "img/img15.8b753407.jpg";